import React from "react";
import { cn } from "../../lib/cn";

/**
 * List - simple vertical list of items.
 * @param {{id: string|number, leading?: React.ReactNode, title: React.ReactNode, subtitle?: React.ReactNode, trailing?: React.ReactNode}[]} items
 * @param {string} [className]
 */
export function List({ items = [], className, ...props }) {
  return (
    <ul className={cn("divide-y divide-neutral-100 dark:divide-neutral-800", className)} {...props}>
      {items.map((item) => (
        <li
          key={item.id}
          className="flex items-center gap-3 px-4 py-3 transition-colors hover:bg-neutral-50 dark:hover:bg-neutral-800"
        >
          {item.leading && <span className="shrink-0">{item.leading}</span>}
          <div className="min-w-0 flex-1">
            <p className="truncate text-sm font-medium text-neutral-900 dark:text-neutral-100">{item.title}</p>
            {item.subtitle && (
              <p className="truncate text-sm text-neutral-500 dark:text-neutral-400">{item.subtitle}</p>
            )}
          </div>
          {item.trailing && <span className="shrink-0">{item.trailing}</span>}
        </li>
      ))}
    </ul>
  );
}
